module.exports = __webpack_public_path__ + "img/reperes-economiques-prix-equilibre-math.8b6ace04.png";